/**
 * Etiquetas legibles para trazabilidad (sin ObjectIds al usuario).
 */

export function folioLabel(guideLike) {
	if (!guideLike) return '';
	const f = guideLike.folio || guideLike.guide_number;
	return f != null && String(f).trim() !== '' ? String(f).trim() : '';
}

/** Etiqueta de contraparte cuando el movimiento apunta a la misma guía (envío parcial interno). */
export function movementCounterpartLabel(row) {
	if (!row) return '—';
	const guideId = row.guide_id != null ? String(row.guide_id) : '';
	const cpId =
		row.counterpart_guide_id != null ? String(row.counterpart_guide_id) : '';
	if (cpId && guideId && cpId === guideId) {
		return 'Stock / misma guía';
	}
	const folio = row.counterpart_guide_folio ?? row.counterpart_guide_number;
	if (folio != null && String(folio).trim() !== '') {
		return String(folio).trim();
	}
	if (cpId) return 'Sin folio';
	return '—';
}

export function movementTypeLabel(type) {
	if (!type) return '-';
	const map = {
		WAREHOUSE_RECEPTION: 'Recepción en bodega',
		WAREHOUSE_SEND_PARTIAL: 'Envío parcial desde bodega',
		INTAKE_DIRECT: 'Ingreso manual RESPEL',
		INTAKE_CANCELLATION: 'Cancelación ingreso RESPEL',
	};
	return map[type] || type;
}

export function roleLabel(role) {
	const map = {
		origin: 'Origen',
		intermediate: 'Transitoria',
		final: 'Destino final',
	};
	return map[role] || 'Guía';
}

export function roleColor(role) {
	const map = {
		origin: 'blue',
		intermediate: 'yellow',
		final: 'teal',
	};
	return map[role] || 'gray';
}

export function roleIcon(role) {
	const map = {
		origin: 'ri-map-pin-line',
		intermediate: 'ri-building-4-line',
		final: 'ri-flag-line',
	};
	return map[role] || 'ri-file-list-3-line';
}

export function movementIcon(movementType) {
	const map = {
		WAREHOUSE_RECEPTION: 'ri-download-2-line',
		WAREHOUSE_SEND_PARTIAL: 'ri-upload-2-line',
		INTAKE_DIRECT: 'ri-inbox-archive-line',
		INTAKE_CANCELLATION: 'ri-close-circle-line',
	};
	return map[movementType] || 'ri-exchange-line';
}

export function statusChangeIcon(event) {
	if (!event) return 'ri-history-line';
	if (event.scope === 'guide_detail') return 'ri-checkbox-circle-line';
	return 'ri-history-line';
}

/** Mantine color tokens: contraste fuerte cabecera (guía) vs ítem (línea). */
export function statusChangeColor(event) {
	if (!event) return 'gray';
	return event.scope === 'guide_detail' ? 'orange' : 'indigo';
}

/** Viñeta más marcada que los pasos de rol (origen / transitoria). */
export function statusChangeBulletVariant() {
	return 'filled';
}

export function statusChangeLabel(event) {
	if (!event) return 'Cambio de estado';
	if (event.scope === 'guide_detail') {
		return event.status_guide_detail_name || 'Cambio de estado';
	}
	// Cabecera: antes solo se mostraba status_guide_name; en flujo destino final
	// "Enviada" se mantiene mientras cambia status_final_destination_management_id,
	// y todas las filas GUÍA parecían duplicadas en la línea de tiempo.
	const sgStr =
		event.status_guide_name != null && event.status_guide_name !== ''
			? String(event.status_guide_name).trim()
			: '';
	const sfdStr =
		event.status_final_destination_name != null &&
		event.status_final_destination_name !== ''
			? String(event.status_final_destination_name).trim()
			: '';
	if (sgStr && sfdStr && sgStr !== sfdStr) {
		return `${sgStr} · ${sfdStr}`;
	}
	return sgStr || sfdStr || 'Cambio de estado';
}

export function formatKg(value) {
	if (value == null || value === '') return '-';
	const n = Number(value);
	if (Number.isNaN(n)) return String(value);
	return `${n.toLocaleString('es-CL', { maximumFractionDigits: 2 })} kg`;
}

export function formatAt(value) {
	if (!value) return '-';
	try {
		return new Date(value).toLocaleString();
	} catch {
		return String(value);
	}
}
